export default () => {
    return new Promise(async (resolve, reject) => {
        try {
            await app.store.dispatch('rms_ui/auth/logout');
            //reject({path:"/"});
            window.location.href = '/';
        } catch (err) {
            console.log(err);
            //reject({path:"/"});
            window.location.href = '/';
        }
    })
}
